import styles from '../Reciept/Reciept.module.css';
import {useEffect, useState} from "react";

export default function Order({ data, printRef, setMessagae }) {
    const order = data.order?.order00 || {};
    const customer = data.order?.order01 || {};
    const cart = data.sbo?.cart || {};
    const company = data.sbo?.cfg?.ftg || {};
    const items = cart.rows || [];
    const [vat, setVat] = useState({});

    useEffect(() => {
        const vat = {}
        cart.rows.forEach(row => {
            const rate = row.taxproc/100
            const price = row.belopp/100

            let current = vat[rate] ?? 0;
            const active =(rate/100) * price
            current += active
            vat[rate] = current
        })

        setVat(vat);
    }, [cart]);

    useEffect(() => {
        if (order.paid !== "1") {
            setMessagae(["Ordern är inte genomförd", "Kontrollera ordern och försök igen"]);
        }
    }, [order.paid]);

    const toCurrency = (val) => {
        let num = parseInt(val || "0", 10) / 100;
        return num.toFixed(2);
    };

    const Item = ({ item }) => {
        const num = parseInt(item.antal || "0", 10);
        const price = parseInt(item.pris || item.price || "0", 10) / 100;
        const total = price * num;
        const txo = Object.values(item.txo)
        const sxo = Object.values(item.sxo)

        return (<div>
            <div className={styles.inline}>
                <p className={styles.itemName}>{num} {item.text.toswe() || ""}</p>
                <p className={styles.itemPrice}>{price.toFixed(2)}</p>
                <p className={styles.itemTotal}>{total.toFixed(2)}</p>
            </div>
            {txo.length > 0 &&
                    <div style={{marginLeft: "10px"}}>
                        {txo.map((item, index)=>(
                            <div key={index} className={styles.inline}>
                                <p className={styles.itemName} >{item.m0nrof} {item.m0text}</p>
                                <p className={styles.itemPrice} >{parseInt(item.m0pris).toFixed(2)}</p>
                                <p className={styles.itemTotal} >{(parseInt(item.m0nrof)*parseInt(item.m0pris)).toFixed(2)}</p>
                            </div>
                            ))}
                    </div>}
            {sxo.length > 0 &&
                    <div style={{marginLeft: "10px"}}>
                        {sxo.map((item, index)=>(
                            <div key={index} className={styles.inline}>
                                <p className={styles.itemName} >{item.m0nrof} {item.m0text}</p>
                                <p className={styles.itemPrice} >{parseInt(item.m0pris).toFixed(2)}</p>
                                <p className={styles.itemTotal} >{(parseInt(item.m0nrof)*parseInt(item.m0pris)).toFixed(2)}</p>
                            </div>
                            ))}
                    </div>}
            </div>
        );
    };

    return (
        <div className={styles.receipt} ref={printRef}>
            <p className={`${styles.big} ${styles.centre}`}>Kvitto</p>
            <p>{data.sbo?.cfg?.text || ""}</p>
            <p>{company.company || ""}</p>
            <p>{company.adress || ""}</p>
            <p>{company.city || ""}</p>
            <div className={styles.inline}>
                <p>Org.nr: {company.orgnr || ""}</p>
                <p>Tel: {company.tele || ""}</p>
            </div>
            <hr/>
            <div className={styles.columns}>
                <div className={styles.column}>
                    <p>Ordernr: {order.orderid.replace(/^0+/, '') || ""}</p>
                    <p>Notanr: {order.notanr || ""}</p>
                    <p>Bord: {order.bord || ""}</p>
                </div>
                <div className={`${styles.column} ${styles.right}`}>
                    <p>Datum: {order.datum || ""}</p>
                    <p>Tid: {order.slot || ""}</p>
                </div>
            </div>
            <hr/>
            <div className={styles.items}>
                {items.map((item, index) => (
                    <Item item={item} key={index}/>
                ))}

            </div>
            {cart.discount && cart.discount > 0 &&
                <div className={styles.inline}>
                    <p className={styles.itemName}>Rabatt: </p>

                    <p className={styles.itemTotal}>{`-${(cart.discount / 100).toFixed(2)}`}</p>
                </div>}
            <div className={styles.inline}>
                <p className={styles.big}>Totalt:</p>
                <p className={styles.big}>{toCurrency(cart.belopp)}</p>
            </div>
            <hr/>
            <div className={styles.momsrader}>
                <div className={styles.inline}>
                    <p>Text</p>
                    <p>Brutto</p>
                    <p>Netto</p>
                    <p>Moms</p>
                </div>
                {Object.keys(vat).map((displayRateStr, index) => {
                    const displayRate = parseFloat(displayRateStr) / 100;
                    const moms = vat[displayRateStr];
                    const realRate = displayRate / (1 - displayRate);
                    const netto = moms / realRate;
                    const brutto = netto + moms;

                    return (
                        <div key={index} className={styles.inline}>
                            <p>Moms {(realRate * 100).toFixed(0)}%</p>
                            <p>{brutto.toFixed(2)}</p>
                            <p>{netto.toFixed(2)}</p>
                            <p>{moms.toFixed(2)}</p>
                        </div>
                    );
                })}
            </div>
            <div className={styles.inline}>
                <p>Moms</p>
                {(Object.values(vat).reduce((sum, value) => sum + value, 0)).toFixed(2)}
            </div>
            <hr/>
            <div className={styles.inline}>
                <p>Betalsätt:</p>
                <p>{getPay(order.betkod)}</p>
            </div>
            {customer.tele && (
                <div className={styles.inline}>
                    <p>Telefon:</p>
                    <p>{"+" + customer.tele}</p>
                </div>
            )}
            <div className={styles.centre}>
                <p>Tack för din beställning!</p>
            </div>
        </div>
    );
}

function getPay(pay) {
    switch (pay) {
        case "swis":
            return "SWISH"
        case "viva":
            return "VIVA"
        default:
            return "-"
    }
}
